"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPromotions = exports.getPromotion = exports.Promotions = void 0;
const typings_1 = require("../typings");
const buy_x_get_y_1 = require("./product/buy-x-get-y");
const fixed_amount_1 = require("./product/fixed-amount");
const fixed_price_1 = require("./product/fixed-price");
const free_giveaway_1 = require("./product/free-giveaway");
const free_lowest_price_1 = require("./product/free-lowest-price");
const percentage_discount_1 = require("./product/percentage-discount");
const fixed_amount_2 = require("./shipping/fixed-amount");
const free_shipping_1 = require("./shipping/free-shipping");
const percentage_discount_2 = require("./shipping/percentage-discount");
// Export Promotions out with new Map()
exports.Promotions = new Map()
    // Set Product promotion
    .set(`${typings_1.PromotionType.PRODUCT}.${typings_1.PromotionSettingsType.BUY_X_GET_Y}`, buy_x_get_y_1.BuyXGetYPromotion)
    .set(`${typings_1.PromotionType.PRODUCT}.${typings_1.PromotionSettingsType.FIXED_PRICE_DISCOUNT}`, fixed_price_1.FixedPriceDiscountPromotion)
    .set(`${typings_1.PromotionType.PRODUCT}.${typings_1.PromotionSettingsType.FIXED_AMOUNT_DISCOUNT}`, fixed_amount_1.FixedAmountDiscountPromotion)
    .set(`${typings_1.PromotionType.PRODUCT}.${typings_1.PromotionSettingsType.FREE_GIVEAWAY}`, free_giveaway_1.FreeGiveawayPromotion)
    .set(`${typings_1.PromotionType.PRODUCT}.${typings_1.PromotionSettingsType.PERCENTAGE_DISCOUNT}`, percentage_discount_1.PercentageDiscountPromotion)
    .set(`${typings_1.PromotionType.PRODUCT}.${typings_1.PromotionSettingsType.FREE_LOWEST_PRICE}`, free_lowest_price_1.FreeLowestPricePromotion)
    // Set Shipping promotion
    .set(`${typings_1.PromotionType.SHIPPING}.${typings_1.PromotionSettingsType.FREE_SHIPPING}`, free_shipping_1.FreeShippingPromotion)
    .set(`${typings_1.PromotionType.SHIPPING}.${typings_1.PromotionSettingsType.FIXED_AMOUNT_DISCOUNT}`, fixed_amount_2.FixedAmountDiscountShippingPromotion)
    .set(`${typings_1.PromotionType.SHIPPING}.${typings_1.PromotionSettingsType.PERCENTAGE_DISCOUNT}`, percentage_discount_2.PercentageDiscountShippingPromotion);
/**
 * Get promotion with promotion's properties
 * @param promotionProperties
 */
function getPromotion(promotionProperties) {
    const Promotion = exports.Promotions.get(`${promotionProperties.type}.${promotionProperties.settings.type}`);
    if (!Promotion) {
        return undefined;
    }
    return new Promotion(promotionProperties);
}
exports.getPromotion = getPromotion;
/**
 * Get promotions with promotions properties
 * @param promotionsProperties
 */
function getPromotions(promotionsProperties) {
    return promotionsProperties.map(getPromotion).filter(Boolean);
}
exports.getPromotions = getPromotions;
//# sourceMappingURL=index.js.map